import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-slate-50 px-6"
          role="alert"
          aria-live="assertive"
          data-testid="error-boundary"
        >
          <div className="max-w-md text-center">
            <p className="text-xs font-medium uppercase tracking-[0.18em] text-rose-600">
              Something went wrong
            </p>
            <h1 className="mt-3 text-3xl font-medium text-slate-900 tracking-tight">
              We hit an unexpected error
            </h1>
            <p className="mt-3 text-slate-600">
              Sorry about this. The error has been logged. You can try again, or head
              back to safety.
            </p>
            <div className="mt-6 flex items-center justify-center gap-2">
              <button
                type="button"
                onClick={this.reset}
                className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                data-testid="error-boundary-retry"
              >
                Try again
              </button>
              <a
                href="/"
                className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
                data-testid="error-boundary-home"
              >
                Go home
              </a>
            </div>
            {process.env.NODE_ENV !== "production" && (
              <pre className="mt-6 text-left text-[10px] text-slate-500 bg-slate-100 rounded-lg p-3 overflow-auto max-h-48">
                {String(this.state.error?.stack || this.state.error)}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
